import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Archive"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.75 1.5H17.25V3H6.75V1.5ZM4.5 6H19.5V7.5H4.5V6ZM3 7.5V10.5H21V7.5H22.5V11.25C22.5 11.3197 22.4903 11.389 22.4711 11.456L19.4711 21.956C19.3792 22.278 19.0849 22.5 18.75 22.5H5.25C4.91514 22.5 4.62085 22.278 4.52886 21.956L1.52886 11.456C1.50971 11.389 1.5 11.3197 1.5 11.25V7.5H3ZM20.7557 12H3.2443L5.81573 21H18.1843L20.7557 12ZM6.75 15H17.25V16.5H6.75V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Archive.vue"]]);
